import styled, { css } from "styled-components";
import { SkeletonRowProps, SkeletonCellProps } from "./types";

export const SkeletonRow = styled.div<SkeletonRowProps>`
    display: flex;
    margin-bottom: 8px;

    & > div {
        height: ${({ rowHeight }) => rowHeight}px;
    }

    &:first-child > div {
        height: ${({ headerHeight }) => headerHeight}px;
    }
`;

// rowHeight={rowHeight}
// headerHeight={headerHeight}
// width={columnWidth}

export const SkeletonCell = styled.div<SkeletonCellProps>`
    background: var(--color-border-light);
    margin-right: 8px;
    border-radius: 4px;
    animation: pulse 1.5s infinite;

    ${({ width, flexGrow }) => flexGrow ? css`
        flex: ${flexGrow};
    ` : css`
        width: ${width}px;
    `};

    @keyframes pulse {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
    }
`;
